import Marquee from "react-fast-marquee";

const DEFAULT = ["Capturing Elegance", "Crafting Memories", "Vista Banquet Hall", "Alexandria, Virginia"];

export default function EditorialMarquee({ items = DEFAULT, dark = false, speed = 28 }) {
  const color = dark ? "text-ivory" : "text-navy";
  const dot = dark ? "text-gold" : "text-gold";
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "border-ivory/15 bg-navy" : "border-navy/10 bg-transparent"} py-7 md:py-9`}
    >
      <Marquee speed={speed} gradient={false} autoFill>
        {items.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className={`font-serif italic text-4xl md:text-6xl font-light px-8 ${color}`}>{t}</span>
            <span className={`text-2xl md:text-3xl ${dot}`}>✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
